export default __webpack_public_path__ + "static/apple-store-d26d93865e59c0f98f0eb484db4922fd.svg";